export function experimentVP() {
    const isAutoTest = location.search.includes('?seo');
    const isEnPricePage = location.pathname === '/price/';
    const isUserLangIncludesEN = getBrowserLanguage().includes('en');
    const isRedirect = !isAutoTest && isEnPricePage && isUserLangIncludesEN;

    if (isRedirect) {
        const country = getCookie('country') ? getCookie('country').split(':')[0] : '';
        const pageHash = window.location.hash;
        const experimentCountries = ['CA', 'UK', 'AU', 'NZ', 'IE', 'GB'];
        const experimentPath = 'price-vp';

        experimentCountries.forEach((countryCode) => {
            if (country.toUpperCase() === countryCode) {
                window.location.replace('/' + experimentPath + '/' + pageHash);
            }
        })
    }

    function getBrowserLanguage() {
        let language = '';

        if (navigator.languages) {
            language = navigator.languages[0];
        } else if (navigator.language) {
            language = navigator.language;
        } else if (navigator.userLanguage) {
            language = navigator.userLanguage;
        }
        language = language ? language.toLowerCase() : 'en';

        return language;
    }

    function getCookie(name) {
        let matches = document.cookie.match(
            new RegExp('(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)')
        );

        if (matches) {
            return decodeURIComponent(matches[1]);
        }
    }
}

function Experiment() {
    if (location.search.indexOf('?seo') === -1) {
        this.experimentCookieName = 'price_comparison';
        this.countryCookieName = 'country';
        this.experimentPages = ['/price/'];
        this.experimentObject = [
            {
                object: 'original',
                percent: 33.3
            },
            {
                object: 'old',
                percent: 33.3
            },
            {
                object: 'new',
                percent: 33.3
            }
        ];
    }

    Experiment.prototype.init = function() {
        this._runExperiment();
    };

    Experiment.prototype.getDatePlus31 = function() {
        var datePlus31 = new Date();

        datePlus31.setTime(datePlus31.getTime() + 31 * 24 * 60 * 60 * 1000);

        datePlus31 = datePlus31.toGMTString();

        return datePlus31;
    };

    Experiment.prototype.getRandomInt = function(start, end) {
        end = end || start;
        return Math.floor(Math.random() * (end - start + 1)) + start;
    };

    Experiment.prototype.getWinnerObject = function(data) {
        var startRandomRange = 0;
        var endRandomRange = 99;
        var randomNumber = this.getRandomInt(startRandomRange, endRandomRange);
        var endStep = 0;
        var winObject = '';

        data.forEach(function(item) {
            if (randomNumber >= endStep && randomNumber < item.percent + endStep) {
                winObject = item.object;
            }

            endStep += item.percent;
        });

        return winObject;
    };

    Experiment.prototype.setCookie = function(name, value) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        var expires = options.expires;

        if (typeof expires === 'number' && expires) {
            var date = new Date();
            var MSINSEC = 1000;

            date.setTime(date.getTime() + expires * MSINSEC);
            expires = options.expires = date;
        }

        if (expires && expires.toUTCString) {
            options.expires = expires.toUTCString();
        }

        value = encodeURIComponent(value);

        var updatedCookie = name + '=' + value;

        for (var propName in options) {
            if (options.hasOwnProperty(propName)) {
                updatedCookie += '; ' + propName;

                var propValue = options[propName];

                if (propValue !== true) {
                    updatedCookie += '=' + propValue;
                }
            }
        }

        document.cookie = updatedCookie;
    };

    Experiment.prototype.getCookie = function(name) {
        var matches = document.cookie.match(
            new RegExp('(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)')
        );

        if (matches) {
            return decodeURIComponent(matches[1]);
        }
    };

    Experiment.prototype._saveResult = function(winnerVersion) {
        this.setCookie(this.experimentCookieName, winnerVersion, {
            expires: this.getDatePlus31(),
            path: '/'
        });
    };

    Experiment.prototype._runCalculation = function() {
        var winnerVersion = this.getWinnerObject(this.experimentObject);

        this._saveResult(winnerVersion);
        this._redirectToWinnerUrl(winnerVersion);
    };

    Experiment.prototype._redirectToWinnerUrl = function(winnerVersion) {
        if (this.experimentPages.indexOf(window.location.pathname) === -1) {
            return;
        }

        var pageHash = window.location.hash;

        switch (winnerVersion) {
            case 'old':
                window.location.replace('/price-va/' + pageHash);
                break;
            case 'new':
                window.location.replace('/price-vb/' + pageHash);
                break;
            default:
                return;
        }
    };

    Experiment.prototype._runExperiment = function() {
        var winnerVersion = this.getCookie(this.experimentCookieName);
        var country = this.getCookie(this.countryCookieName).split(':')[0];

        if (country !== 'JP') {
            if (typeof winnerVersion !== 'undefined') {
                this._redirectToWinnerUrl(winnerVersion);
            } else {
                this._runCalculation();
            }
        } else {
            window.location.replace('/price-ve/');
        }
    };
}



// WEBPACK FOOTER //
// ./assets/js/projects/price/includes/experiment.js